"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDomainPage = void 0;
const react_1 = __importDefault(require("react"));
const modals_1 = require("@mdigital/components/dist/utils/modals");
const utils_1 = require("../../../common/utils");
const AddDomain_1 = require("./Modals/AddDomain");
const WindowsIcon_1 = require("./WindowsIcon");
const styled_1 = require("./styled");
const alchemy_ui_1 = require("@m/alchemy-ui");
const VerticalStack_1 = __importDefault(require("@mdigital/components/dist/components/VerticalStack"));
const TextPathPrefix = 'app.pages.administration.domainsList';
const NoDomainTitle = `${TextPathPrefix}.noDomains`;
const AddDomainText = `${TextPathPrefix}.addDomain`;
const Link = `${TextPathPrefix}.link`;
const EmptyDomainPage = (props) => {
    const { domains } = props;
    const domainNames = domains.map((dom) => dom.domainName);
    const addDomain = () => {
        modals_1.ModalsService.showCustomModal(AddDomain_1.AddDomain, {
            domains: domainNames,
            onSubmit: (item) => {
                props.addNewDomain(item);
            },
            closeModal: () => modals_1.ModalsService.closeModals(),
            render: (props) => (react_1.default.createElement(AddDomain_1.AddDomain, Object.assign({}, props, props))),
        });
    };
    return (react_1.default.createElement(styled_1.EmptyBlock, null,
        react_1.default.createElement(WindowsIcon_1.WindowsIcon, { title: "Circle", description: "Outline of a Circle", size: "96", palette: 'expressiveNeutral', color: "highlight" }),
        react_1.default.createElement(VerticalStack_1.default, { gap: (0, alchemy_ui_1.units)(3), alignItems: 'center' },
            react_1.default.createElement(VerticalStack_1.default, { gap: (0, alchemy_ui_1.units)(1), alignItems: 'center' },
                react_1.default.createElement(styled_1.Header, null, (0, utils_1.getSingleText)(NoDomainTitle)),
                react_1.default.createElement(styled_1.SubHeader, null,
                    react_1.default.createElement("a", { href: 'https://docs.medallia.com/en/?resourceId=mdw-predef-domain' }, (0, utils_1.getSingleText)(Link)))),
            react_1.default.createElement(alchemy_ui_1.Button, { onClick: addDomain }, (0, utils_1.getSingleText)(AddDomainText)))));
};
exports.EmptyDomainPage = EmptyDomainPage;
